<template>
  <div class="wrap-table">
    <SearchUsers :group="group"/>
    <table
      class="table-users stripe"
    >
      <th>Nombre</th>
      <th>Admin</th>
      <th>Lider</th>
      <th class="text-center">...</th>
      <tr :key="indextr" v-for="(user, indextr) in users" data-cy="user">
        <td>
          <span class="d-flex">
            <img
              v-if="user.avatar"
              key="onlineImg"
              :src="user.avatar"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer"
            />
            <img
              v-if="!user.avatar"
              key="onlineImg"
              :src="noAvatar"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer"
            />
            <span class="ml-3" style="line-height: 40px;">
              {{ user.nombre }}
            </span>
          </span>
        </td>
        <td>
          <vs-chip
            v-tooltip="'Administrador'"
            color="warning"
            v-if="user.esAdministradorEmpresa === 'Y'"
          >
            <vs-avatar icon="verified_user"/>
            admin
          </vs-chip>
          <vs-chip
            v-tooltip="'No admin'"
            v-if="user.esAdministradorEmpresa !== 'Y'"
          >
            <vs-avatar icon="verified_user"/>
            no
          </vs-chip>
        </td>
        <td>
          <vs-chip
            v-tooltip="'Lider'"
            color="success"
            transparent
            v-if="user.esLider === 'Y'"
          >
            <vs-avatar icon="flag"/>
            lider
          </vs-chip>
        </td>
        <td>
          <div class="wrap-actions">
            <CheckPermission permission="ED074">
              <b-button
                v-tooltip="'Editar usuario'"
                variant="flat-primary"
                class="btn-icon rounded-circle"
                @click="editUser(user)"
              >
                <feather-icon
                  size="14"
                  icon="EditIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
            </CheckPermission>
            <CheckPermission
              permission="ED073"
              v-if="group.nombre && group.tieneLider === 'N'"
            >
              <b-button
                v-tooltip="'Lider'"
                variant="flat-primary"
                class="btn-icon rounded-circle"
                @click="markLeader(user)"
              >
                <feather-icon
                  size="12"
                  icon="FlagIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
            </CheckPermission>
            <!-- ASSIGN ROLES -->
            <b-dropdown

              variant="link"
              no-caret
              right
            >
              <template #button-content>
                <feather-icon
                  size="14"
                  icon="MoreVerticalIcon"
                  class="align-middle text-body"
                  data-cy="options"
                />
              </template>
              <b-dropdown-item
                v-has-permission="'*'"
                @click="detailUser(user)"
                data-cy="user-detail"
              >
                Ver Detalle
              </b-dropdown-item>
              <b-dropdown-item
                v-has-permission="'ED097'"
                @click="userBinnacle(user)"
                data-cy="binnacle"
              >
                Bitácora
              </b-dropdown-item>
              <b-dropdown-item
                v-has-permission="'ED219'"
                @click="groupsUser(user)"
                data-cy="groups-user"
              >
                {{ titleActionUserGroups }}
              </b-dropdown-item>
              <b-dropdown-item
                v-in-environment="'desarrollo'"
                v-has-permission="'ED086'"
                @click="assignRoles(user)"
                data-cy="assign-roles"
              >
                Asignar Roles
              </b-dropdown-item>
              <b-dropdown-item
                v-in-environment="'desarrollo'"
                v-has-permission="'ED086'"
                @click="copyRoles(user)"
                data-cy="copy-roles"
              >
                Copiar Roles
              </b-dropdown-item>
              <b-dropdown-item
                v-has-permission="'ED152'"
                @click="assignProfiles(user)"
                data-cy="assign-profiles"
              >
                Asignar Perfiles
              </b-dropdown-item>
              <b-dropdown-item
                v-has-permission="'ED086'"
                @click="copyProfiles(user)"
                data-cy="copy-profiles"
              >
                Copiar Perfiles
              </b-dropdown-item>
              <b-dropdown-item
                v-has-permission="'ED071'"
                @click="substituteUser(user)"
                data-cy="substitute"
              >
                Suplentes
              </b-dropdown-item>
              <b-dropdown-item
                v-if="company.firmaSimple"
                @click="simpleSigner(user)"
                data-cy="simple-signer"
              >
                <span>
                  Firma Simple
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="company.firmaAvanzada"
                @click="advancedSigner(user)"
                data-cy="advanced-signer"
              >
                <span>
                  Firma Avanzada
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="workerData(user)"
                data-cy="worker-data"
              >
                <span>
                  Información laboral
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </table>
    <b-modal
      ref="userGroups"
      hide-footer
      :title="titleModalUserGroups"
    >
     <div
       class="group-element"
       v-for="group in userGroups" :key="group.id"
     >
       <strong>- </strong>
       <span>{{group.nombre}}</span>
     </div>
      <div v-if="!userGroups.length">
        <h4>No se encontraron registros</h4>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      ref="user"
      hide-footer
      title="Datos del usuario"
      no-close-on-backdrop
    >
      <manage-user
        :action="actionUser"
        :user="user"
        @close-manage-user="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="binnacle"
      hide-footer
      :title="`Bitácora del usuario ${user.nombre}`"
    >
      <binnacle-user
        :user="user"
        :binnacle-user="binnacleUser"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="substitute"
      hide-footer
      no-close-on-backdrop
      :title="`Suplencia para el usuario ${user.nombre}`"
    >
      <substitute-user
        :user="user"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      centered
      id="simple-signature-modal"
      modal-class="modal-primary"
      size="lg"
      ref="simplesign"
      hide-footer
      no-close-on-backdrop
      :title="`Firma Simple`"
    >
      <FormConfigureSign :user="user" :type="'simple'" :ambit="'unidad'"/>
    </b-modal>
    <b-modal
      centered
      id="advances-signature-modal"
      modal-class="modal-primary"
      size="lg"
      ref="advancedSign"
      hide-footer
      no-close-on-backdrop
      title-class="w-100"
    >
      <template #modal-title>
        <div class="d-flex justify-content-between">
          <div>{{`Firma Avanzada - ${getSignName()}`}}</div>
          <div>{{user.nombre}}</div>
        </div>
      </template>
      <FormConfigureSign
        :user="user"
        type="avanzada"
        ambit="unidad"
        v-on:cancel="cancelAdvancesSing"
      />
    </b-modal>
    <!-- ASSIGN ROLES MODAL -->
    <b-modal
      size="lg"
      ref="assignRolesModal"
      hide-footer
      no-close-on-backdrop
      :title="`Asignar Roles a ${user.nombre}`"
    >
      <assign-roles-form
        :user="user"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="assignProfilesModal"
      hide-footer
      no-close-on-backdrop
      :title="`Asignar Perfiles a ${user.nombre}`"
    >
      <assign-profiles-form
        :user="user"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="copyRolesModal"
      hide-footer
      no-close-on-backdrop
      :title="`Copiar Roles desde ${user.nombre}`"
    >
      <copy-roles-users
        :user="user"
        :users-general="usersGeneral"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="copyProfilesModal"
      hide-footer
      no-close-on-backdrop
      :title="`Copiar Perfiles desde ${user.nombre}`"
    >
      <copy-profiles-users
        :user="user"
        :users-general="usersGeneral"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      centered
      size="lg"
      ref="workerInformationModal"
      hide-footer
      no-close-on-backdrop
      :title="`Información laboral de ${user.nombre}`"
    >
      <WorkerInformation
        :user="user"
        @close-action="closeModal"
      />
    </b-modal>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ManageUser from '@/febos/global/management/vistas/components/ManageUser';
import SubstituteUser from '@/febos/global/management/vistas/components/SubstituteUser';
import AssignRolesForm from '@/febos/global/management/vistas/components/AssignRolesForm';
import AssignProfilesForm from '@/febos/global/management/vistas/components/AssignProfilesForm';
import CopyRolesUsers from '@/febos/global/management/vistas/components/CopyRolesUsers';
import CopyProfilesUsers from '@/febos/global/management/vistas/components/CopyProfilesUsers';
import WorkerInformation from '@/febos/global/management/vistas/components/WorkerInformation';
import BinnacleUser from '@/febos/global/management/vistas/components/BinnacleUser';
import FormConfigureSign from '@/febos/global/usuario/components/sign/FormConfigureSign';
import SearchUsers from '@/febos/global/management/vistas/components/SearchUsers';
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'UserTable',
  components: {
    AssignProfilesForm,
    AssignRolesForm,
    BinnacleUser,
    CopyProfilesUsers,
    CopyRolesUsers,
    CheckPermission,
    FormConfigureSign,
    ManageUser,
    SubstituteUser,
    SearchUsers,
    WorkerInformation
  },
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      userGroups: [],
      actionUser: '',
      usersGeneral: [],
      user: {},
      binnacleUser: [],
      noAvatar: require('../../../../../assets/images/no-avatar.svg'),
    };
  },
  props: {
    users: { type: Array, default: () => [] },
    group: Object
  },
  watch: {

  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'successAction',
      'company',
      'usersCompanyAssign',
      'groupsCompany',
    ]),
    titleModalUserGroups() {
      if (this.product === 'aduanas') {
        return `Aduanas a las que pertenece ${this.user.nombre}`;
      }
      return `Grupos del usuario ${this.user.nombre}`;
    },
    titleActionUserGroups() {
      if (this.product === 'aduanas') {
        return 'Ver aduanas';
      }
      return 'Ver grupos';
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getSubstituteUser',
      'getUsersCompanyToAssign',
      'markLiderInGroup',
      'getBinnacle'
    ]),
    getSignName() {
      if (this.company.firmaAvanzada === 'esign7') {
        return 'esign';
      }
      return this.company.firmaAvanzada;
    },
    async groupsUser(user) {
      this.user = { ...user };
      this.userGroups = [];
      const response = await ioCompanyGroups(
        {
          empresaId: this.company.id,
          filtros: `usuarioId:${user.id}`
        }
      );
      this.userGroups = response.data.grupos;
      this.$refs.userGroups.show();
    },
    editUser(user) {
      this.user = { ...user };
      this.actionUser = 'edit';
      this.$refs.user.show();
    },
    detailUser(user) {
      this.user = { ...user };
      this.actionUser = 'visualize';
      this.$refs.user.show();
    },
    async userBinnacle(user) {
      this.binnacleUser = await this.getBinnacle(user.id);
      this.user = { ...user };
      this.$refs.binnacle.show();
    },
    assignRoles(user) {
      this.user = { ...user };
      this.$refs.assignRolesModal.show();
    },
    assignProfiles(user) {
      this.user = { ...user };
      this.$refs.assignProfilesModal.show();
    },
    async copyRoles(user) {
      await this.getUsersCompanyToAssign({
        empresaId: this.company.id,
        pagina: 1,
        filas: 100000
      });
      this.user = { ...user };
      this.usersGeneral = this.usersCompanyAssign;
      this.$refs.copyRolesModal.show();
    },
    async copyProfiles(user) {
      await this.getUsersCompanyToAssign({
        empresaId: this.company.id,
        pagina: 1,
        filas: 100000
      });
      this.user = { ...user };
      this.usersGeneral = this.usersCompanyAssign;
      this.$refs.copyProfilesModal.show();
    },
    async substituteUser(user) {
      this.user = { ...user };
      await this.getSubstituteUser({
        empresaId: this.company.id,
        filtros: `usuarioId:${user.id}`
      });
      this.$refs.substitute.show();
    },
    simpleSigner(user) {
      this.user = { ...user };
      this.$refs.simplesign.show();
    },
    advancedSigner(user) {
      this.user = { ...user };
      this.$refs.advancedSign.show();
    },
    workerData(user) {
      this.user = { ...user };
      this.$refs.workerInformationModal.show();
    },
    markLeader(user) {
      const updateGroup = this.groupsCompany.find((group) => group.id === this.group.id);
      if (user.esLider === 'N' && updateGroup.tieneLider === 'Y') {
        this.$bvToast.toast(
          'Este grupo ya tiene un Lider, inhabilita el actual para poder asignar uno nuevo',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      const body = {
        grupoId: this.group.id,
        usuarioId: user.id,
        esLider: 'Y'
      };
      if (user.esLider === 'Y') {
        body.esLider = 'N';
      }
      this.markLiderInGroup({ empresaId: this.company.id, body });
    },
    cancelAdvancesSing() {
      this.$refs.advancedSign.hide();
    },
    closeModal(event) {
      if (this.$refs.substitute) {
        this.$refs.substitute.hide();
      }
      if (event) {
        this.$bvToast.toast(
          'Usuario editado correctamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 5000
          }
        );
        this.$refs.user.hide();
        return;
      }
      if (this.$refs.assignRolesModal) {
        this.$refs.assignRolesModal.hide();
      }
      if (this.$refs.assignProfilesModal) {
        this.$refs.assignProfilesModal.hide();
      }
      if (this.$refs.copyRolesModal) {
        this.$refs.copyRolesModal.hide();
      }
      if (this.$refs.binnacle) {
        this.$refs.binnacle.hide();
      }
      if (this.$refs.workerInformationModal) {
        this.$refs.workerInformationModal.hide();
      }
      if (this.$refs.advancedSign) {
        this.$refs.advancedSign.hide();
      }
      if (this.$refs.copyProfilesModal) {
        this.$refs.copyProfilesModal.hide();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap-actions {
  display: flex;
  justify-content: space-around;
}
.table-users {
  width: 100%;
}

tr:nth-child(even) {
  background-color: #f0f0f0;
}
.wrap-table {
  height: 600px;
  overflow-y: auto;
}
.group-element {
  margin-top: 4px;
}
</style>
